import axios from 'axios'

const API_URL = import.meta.env.VITE_API_URL
const TIMEOUT = import.meta.env.VITE_TIMEOUT

export const isCancel = (error) => {
  return axios.isCancel(error)
}

export default axios.create({
  baseURL: API_URL,
  headers: {
    'frontend-version': `${import.meta.env.BASE_VERSION}@${import.meta.env.GIT_HASH}`,
    'Content-Type': 'application/json',
    'Released-At': `${import.meta.env.VITE_RELEASED_AT}`
    // Authorization: '' -> dont use if empty
  },
  timeout: TIMEOUT,
  responseType: 'json',
  responseEncoding: 'utf8',
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF_TOKEN',
  withCredentials: true,
  showMessages: true,
  hideSuccessMessages: false // sometimes we need to ignore only success messages
})
